import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-inactivity-warning-modal',
    template: `
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa-solid fa-triangle-exclamation bff-text" style="color: #FFD43B;"></i>
        {{ 'inactivity.title' | translate }}
      </h5>
    </div>
    <div class="modal-body">
      <p>
        {{ 'inactivity.message' | translate:{minutes: minutes} }}
      </p>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="bff-button bff-button--primary bff-text"
        (click)="cancel()"
      >
        <i class="fa-solid fa-xmark"></i>
        <span class="bff-hide-mobile">{{ 'inactivity.cancel' | translate }}</span>
      </button>
    </div>
  `,
    imports: [TranslateModule]
})
export class InactivityWarningModalComponent {
  modal = inject(NgbActiveModal);

  @Input() minutes = 1;
  cancel() {
    this.modal.close('cancel');
  }
}
